"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var React = require("react");

var FaCheck_1 = require("@react-icons/all-files/fa/FaCheck");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var HiddenInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* visually hidden but still accessible */\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  left: 1px;\n  white-space: nowrap;\n"], ["\n  /* visually hidden but still accessible */\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  left: 1px;\n  white-space: nowrap;\n"])));
var Checkmark = styled_components_1.default(FaCheck_1.FaCheck)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 50%;\n  bottom: 50%;\n  transform: translate(50%, 50%);\n"], ["\n  position: absolute;\n  right: 50%;\n  bottom: 50%;\n  transform: translate(50%, 50%);\n"])));
var Label = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  user-select: none;\n  margin-right: 15px;\n"], ["\n  user-select: none;\n  margin-right: 15px;\n"])));
var Button = styled_components_1.default.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  var calcSize = Math.ceil(p.size * 1.15);
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: inline-block;\n    outline: 0;\n    width: ", "px;\n    min-width: ", "px;\n    height: ", "px;\n    position: relative;\n    user-select: none;\n    border-radius: ", "px;\n    border: 1px solid ", ";\n    transition: all 0.2s;\n    background: ", ";\n    box-shadow: 0 0 4px ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", " {\n      font-size: ", "px;\n    }\n  "], ["\n    box-sizing: border-box;\n    display: inline-block;\n    outline: 0;\n    width: ", "px;\n    min-width: ", "px;\n    height: ", "px;\n    position: relative;\n    user-select: none;\n    border-radius: ", "px;\n    border: 1px solid ", ";\n    transition: all 0.2s;\n    background: ", ";\n    box-shadow: 0 0 4px ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", " {\n      font-size: ", "px;\n    }\n  "])), calcSize, calcSize, calcSize, p.borderRadius, p.borderColorOff, p.backgroundColorOff, p.shadowColorOff, p.hasLabel && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        margin-right: ", "px;\n\n        ", "\n      "], ["\n        margin-right: ", "px;\n\n        ", "\n      "])), calcSize / 2, p.alternate && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            margin-right: 0;\n            margin-left: ", "px;\n          "], ["\n            margin-right: 0;\n            margin-left: ", "px;\n          "])), calcSize / 2)), p.isOn && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0 0 4px ", ";\n      "], ["\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0 0 4px ", ";\n      "])), p.backgroundColorOn, p.borderColorOn, p.shadowColorOn), p.isDisabled && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        border-color: ", ";\n        background-color: ", ";\n      "], ["\n        border-color: ", ";\n        background-color: ", ";\n      "])), p.disabledBorderColor, p.disabledBackgroundColor), Checkmark, calcSize * 0.75);
});
var CheckboxContainer = styled_components_1.default.label(function (_a) {
  var theme = _a.theme,
      labelSize = _a.labelSize,
      alternate = _a.alternate,
      isDisabled = _a.isDisabled,
      isFocused = _a.isFocused,
      focusColor = _a.focusColor,
      borderColorOn = _a.borderColorOn,
      shadowColorOn = _a.shadowColorOn,
      size = _a.size,
      borderRadius = _a.borderRadius;
  return styled_components_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    position: relative;\n    display: inline-flex;\n    flex-direction: ", ";\n    align-items: center;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s;\n    font-size: ", "px;\n    line-height: ", "px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: -4px;\n      top: -4px;\n      width: 100%;\n      height: 100%;\n      padding: 3px;\n      border-radius: ", "px;\n      border: 1px solid transparent;\n      transition: border-color 0.2s;\n    }\n\n    &:hover {\n      cursor: ", ";\n\n      ", " {\n        ", "\n      }\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    position: relative;\n    display: inline-flex;\n    flex-direction: ", ";\n    align-items: center;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s;\n    font-size: ", "px;\n    line-height: ", "px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: -4px;\n      top: -4px;\n      width: 100%;\n      height: 100%;\n      padding: 3px;\n      border-radius: ", "px;\n      border: 1px solid transparent;\n      transition: border-color 0.2s;\n    }\n\n    &:hover {\n      cursor: ", ";\n\n      ", " {\n        ", "\n      }\n    }\n\n    ", "\n\n    ", "\n  "])), alternate ? 'row-reverse' : 'row', labelSize || size, labelSize || size, borderRadius, isDisabled ? 'not-allowed' : 'pointer', Button, !isDisabled && styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n            border-color: ", ";\n            box-shadow: 0 0 4px ", ";\n          "], ["\n            border-color: ", ";\n            box-shadow: 0 0 4px ", ";\n          "])), borderColorOn, shadowColorOn), isDisabled && styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        ", " {\n          color: ", ";\n        }\n      "], ["\n        ", " {\n          color: ", ";\n        }\n      "])), Label, theme.colors.disabledColor), isFocused && styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        &::before {\n          border-color: ", ";\n          transition: border-color 0.2s;\n        }\n      "], ["\n        &::before {\n          border-color: ", ";\n          transition: border-color 0.2s;\n        }\n      "])), focusColor || theme.colors.primary));
});

function Checkbox(_a) {
  var _b = _a.onChange,
      onChange = _b === void 0 ? function () {
    return {};
  } : _b,
      ariaLabel = _a.ariaLabel,
      _c = _a.isDisabled,
      isDisabled = _c === void 0 ? false : _c,
      _d = _a.size,
      size = _d === void 0 ? 24 : _d,
      checkedColor = _a.checkedColor,
      offColor = _a.offColor,
      disabledColor = _a.disabledColor,
      focusColor = _a.focusColor,
      label = _a.label,
      _e = _a.alternate,
      alternate = _e === void 0 ? false : _e,
      checkmarkColor = _a.checkmarkColor,
      _f = _a.variant,
      variant = _f === void 0 ? 'default' : _f,
      _g = _a.labelSize,
      labelSize = _g === void 0 ? 16 : _g,
      id = _a.id,
      on = _a.on,
      props = __rest(_a, ["onChange", "ariaLabel", "isDisabled", "size", "checkedColor", "offColor", "disabledColor", "focusColor", "label", "alternate", "checkmarkColor", "variant", "labelSize", "id", "on"]);

  var theme = styled_components_1.useTheme();

  var _h = React.useState(on),
      isOn = _h[0],
      setOn = _h[1];

  var _j = React.useState(false),
      isFocused = _j[0],
      setFocus = _j[1];

  var handleChange = function handleChange(e) {
    e.stopPropagation();
    if (isDisabled) return;
    var newValue = !isOn;
    setOn(newValue);

    if (typeof onChange === 'function') {
      onChange(newValue);
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter') {
      handleChange(e);
    }
  };

  var handleFocus = function handleFocus() {
    setFocus(!isFocused);
  };

  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Checkbox', variant, size);
  var sharedProps = {
    alternate: alternate,
    size: size,
    checkedColor: checkedColor,
    isDisabled: isDisabled,
    disabledColor: disabledColor,
    isFocused: isFocused,
    labelSize: labelSize,
    offColor: offColor,
    hasLabel: !!label,
    isOn: isOn
  };
  React.useEffect(function () {
    setOn(on);
  }, [on]);
  return React.createElement(CheckboxContainer, __assign({
    "aria-label": ariaLabel || label || 'Checkbox',
    htmlFor: id,
    focusColor: focusColor
  }, sharedProps, themeStyles, props), React.createElement(HiddenInput, __assign({
    type: "checkbox",
    checked: isOn,
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    onFocus: handleFocus,
    onBlur: handleFocus,
    id: id
  }, sharedProps)), React.createElement(Button, __assign({}, sharedProps, themeStyles), isOn && React.createElement(Checkmark, {
    color: checkmarkColor || themeStyles.checkmarkColor
  })), label && React.createElement(Label, null, label));
}

exports.Checkbox = Checkbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;